import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX Vault Deployer API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const DEX_VAULT_DEPLOYER_API_ENDPOINTS = {
  deployVault: {
    generated: 'apiControllerDeployVault',
    method: 'post',
    path: '/web/deploy/:vaultId',
  },
  addDeployer: {
    generated: 'apiControllerAddDeployer',
    method: 'post',
    path: '/web/add_deployer/:blockchainId',
  },
  findDeployer: {
    generated: 'apiControllerFindDeployer',
    method: 'get',
    path: '/web/find_deployer/:blockchainId/:address',
  },
  getDeployer: {
    generated: 'apiControllerGetDeployer',
    method: 'get',
    path: '/web/deployer/:blockchainId/:deployerId',
  },
  withdrawGas: {
    generated: 'apiControllerWithdrawGas',
    method: 'post',
    path: '/web/withdraw_gas',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexVaultDeployerEndpointName = keyof typeof DEX_VAULT_DEPLOYER_API_ENDPOINTS;
